import { useLocation, useParams } from 'react-router-dom'
import {
  AtendimentoType,
  IconPaths,
  initialQueryState,
  OptionsHelper,
  showError,
  useDebounce,
} from '../../../../../../../_metronic/helpers'
import {
  Button,
  CustomSelect,
  CustomTabs,
  IOption,
  Label,
  useModal,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useEffect, useMemo, useState } from 'react'
import { ProfissionalValoresModal } from '../modal/ProfissionalValoresModal'
import { getFuncionarioById } from '../../../funcionarios-list/core/_requests'

export const ProfissionalValoresListHeader = () => {
  const { updateState } = useQueryRequest()
  const { showModal } = useModal()
  const { id } = useParams<{ id: string }>()

  const location = useLocation() as {
    state?: { nome?: string }
  }

  const nomeInicial = location.state?.nome
  const [nome, setNome] = useState<string>(nomeInicial ?? '')
  const [activeTab, setActiveTab] = useState<'atuais' | 'historico'>('atuais')
  const [filters, setFilters] = useState({
    tipoAtendimento: undefined as IOption<AtendimentoType> | undefined,
    especialidade: undefined as IOption<number> | undefined,
  })

  const debouncedFilters = useDebounce(filters, 500)

  const tabs: { id: 'atuais' | 'historico'; label: string }[] = [
    { id: 'atuais', label: 'Valores atuais' },
    { id: 'historico', label: 'Histórico' },
  ]

  const search = useMemo(() => {
    return [
      debouncedFilters.tipoAtendimento ? `tipo:${debouncedFilters.tipoAtendimento.value}` : '',
      debouncedFilters.especialidade ? `especialidade:${debouncedFilters.especialidade.value}` : '',
    ]
      .filter(Boolean)
      .join(',')
  }, [debouncedFilters])

  const handleChangeTab = (tab: 'atuais' | 'historico') => {
    setActiveTab(tab)
    updateState({
      tab,
      page: 0,
    })
  }

  const openModal = () =>
    showModal({
      title: 'Cadastrar valor',
      content: <ProfissionalValoresModal idProfissional={Number(id)} />,
    })

  useEffect(() => {
    updateState({
      search,
      ...initialQueryState,
    })
  }, [search, updateState])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (nomeInicial) return
        const funcionario = await getFuncionarioById(Number(id))
        setNome(funcionario.pessoa?.nome as string)
      } catch (error) {
        showError(error)
      }
    }
    fetchData()
  }, [id, nomeInicial])

  return (
    <div className='card-header border-0 pt-6 d-flex flex-column gap-4'>
      <div className='d-flex justify-content-between align-items-center w-100'>
        <h2>Valores de {nome}</h2>
      </div>
      <div className='row'>
        <div className='col-md-5'>
          <Label className='mb-1'>Tipo de atendimento</Label>
          <CustomSelect
            placeholder='Selecione um tipo'
            onChange={(tipoAtendimento) => setFilters((prev) => ({ ...prev, tipoAtendimento }))}
            fetchOptions={OptionsHelper.getOptionsTiposAtendimento}
          />
        </div>
        <div className='col-md-5'>
          <Label className='mb-1'>Especialidade</Label>
          <CustomSelect
            placeholder='Selecione uma especialidade'
            onChange={(especialidade) => setFilters((prev) => ({ ...prev, especialidade }))}
            fetchOptions={OptionsHelper.getOptionsEspecialidades}
          />
        </div>
        <div className='d-flex flex-end align-items-center col-md-2'>
          {activeTab === 'atuais' && (
            <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
              Novo valor
            </Button>
          )}
        </div>
      </div>

      <CustomTabs tabs={tabs} activeTab={activeTab} onChange={handleChangeTab} />
    </div>
  )
}
